import { Column } from "react-table";
import { Grid } from "../Grid";
import { ICompliance } from "../../api/ICompliance";
import { ILicencesGridProps } from "./LicencesGridProps";
import { GetLicencesByMeetingFetchUrl } from "../../api/LicenceVersion";
import { getIconForType } from "../icons/LeapIcons";
import { GetLicenceProfilePageUrl } from "../../leap-pages/routeFactory";
import { Link } from "react-router-dom";

const LicencesGrid = ({
  regardingObjectId,
  regardingObjectType,
}: ILicencesGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetLicencesByMeetingFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(regardingObjectId);

  const tableColumnsBig: Column<Record<string, ICompliance>>[] = [
    {
      Header: "Authorisation No.",
      accessor: "reg_no",
      Filter: false,
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetLicenceProfilePageUrl(
                  rowInfo.row.original.licenceprofile_number
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Authorisation Name",
      accessor: "licence_name",
      Filter: false,
    },
    {
      Header: "Authorisation Type",
      accessor: "licence_type",
      Filter: false,
    },
    {
      Header: "Authorisation Status",
      accessor: "licence_status",
      Filter: false,
    },
    {
      Header: "Authorisation Sub Status",
      accessor: "licence_substatus",
      Filter: false,
    },
  ];

  const tableColumnsSmall: Column<Record<string, ICompliance>>[] = [
    {
      Header: "Authorisation No.",
      accessor: "reg_no",
      Filter: false,
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetLicenceProfilePageUrl(
                  rowInfo.row.original.licenceprofile_number
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Authorisation Name",
      accessor: "licence_name",
      Filter: false,
    },
    {
      Header: "Authorisation Type",
      accessor: "licence_type",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={false}
          enableQuickFind={false}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={false}
          enableQuickFind={false}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export default LicencesGrid;
